import { render, staticRenderFns } from "./NoTemplatesModal.vue?vue&type=template&id=29c6c2d1&"
import script from "./NoTemplatesModal.vue?vue&type=script&lang=js&"
export * from "./NoTemplatesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports